import { render, staticRenderFns } from "./ExamButton.vue?vue&type=template&id=9cdb949a"
import script from "./ExamButton.vue?vue&type=script&lang=js"
export * from "./ExamButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports